import * as React from 'react';
import {
  UserList, UserShow, UserCreate, UserEdit,
  CourseList, CourseShow, CourseCreate, CourseEdit,
  RoundList, RoundShow, RoundCreate, RoundEdit,
  LeaderboardList, LeaderboardShow, LeaderboardCreate, LeaderboardEdit,
  CompetitionList, CompetitionShow, CompetitionCreate, CompetitionEdit,
  NewsFeedList, NewsFeedShow, NewsFeedCreate, NewsFeedEdit,
  ProductList, ProductShow, ProductCreate, ProductEdit,
} from './admin';
import { Admin, Resource } from 'react-admin';
import {
  FirebaseDataProvider,
  FirebaseAuthProvider,
} from 'react-admin-firebase';

import firebase from "firebase/compat/app";
import 'firebase/compat/storage';

import PeopleIcon from '@mui/icons-material/People';
import GolfCourseIcon from '@mui/icons-material/GolfCourse';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import ArticleIcon from '@mui/icons-material/Article';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';

import * as Users from "./admin/users";

import CustomLoginPage from './CustomLoginPage';
import EventMonitor from './EventMonitor';

let firebaseConfig;
try {
  firebaseConfig = JSON.parse(process.env.REACT_APP_FIREBASE_CONFIG);
} catch (error) {
  console.error('Error parsing (maybe quotes aren\'t escaped?): ', {REACT_APP_FIREBASE_CONFIG: process.env.REACT_APP_FIREBASE_CONFIG}, error);
}

const firebaseApp = firebase.initializeApp(firebaseConfig);
export const storage = firebase.storage(firebaseApp)
console.log({firebaseConfig, firebaseApp});

const authProvider = FirebaseAuthProvider(firebaseConfig);
const dataProvider = FirebaseDataProvider(firebaseConfig, {
  logging: true,
  app: firebaseApp,
  persistence: 'local',
  dontAddIdFieldToDoc: true,
  lazyLoading: {
    enabled: true,
  },
  firestoreCostsLogger: {
    enabled: true,
  },
});

class App extends React.Component {
  render() {
    return (
      <>
        <Admin
          loginPage={CustomLoginPage}
          dataProvider={dataProvider}
          authProvider={authProvider}
        >
          <Resource
            name="users"
            icon={PeopleIcon}
            list={UserList}
            show={UserShow}
            create={UserCreate}
            edit={UserEdit}
          />
          <Resource
            name="courses"
            icon={GolfCourseIcon}
            list={CourseList}
            show={CourseShow}
            create={CourseCreate}
            edit={CourseEdit}
          />
          <Resource
            name="rounds"
            icon={SportsSoccerIcon}
            list={RoundList}
            show={RoundShow}
            create={RoundCreate}
            edit={RoundEdit}
          />
          <Resource
            name="leaderboard"
            icon={EmojiEventsIcon}
            list={LeaderboardList}
            show={LeaderboardShow}
            create={LeaderboardCreate}
            edit={LeaderboardEdit}
          />
          <Resource
            name="competitions"
            icon={EmojiEventsIcon}
            list={CompetitionList}
            show={CompetitionShow}
            create={CompetitionCreate}
            edit={CompetitionEdit}
          />
          <Resource
            name="newsfeed"
            icon={ArticleIcon}
            list={NewsFeedList}
            show={NewsFeedShow}
            create={NewsFeedCreate}
            edit={NewsFeedEdit}
          />
          <Resource
            name="products"
            icon={ShoppingCartIcon}
            list={ProductList}
            show={ProductShow}
            create={ProductCreate}
            edit={ProductEdit}
          />
        </Admin>
        <EventMonitor />
      </>
    );
  }
}

export default App;
